import { CommandBase } from "../../../common/services/cqs/commandManager";

export class SetExtraSortimentCommand extends CommandBase {
    destineringsId: number;
    sortimentIds: number[];
    // eslint-disable-next-line sonarjs/public-static-readonly
    static $type = "SetExtraSortimentCommand";
    constructor(init: (instance: SetExtraSortimentCommand) => void) {
        super(SetExtraSortimentCommand.$type);
        init(this);
    }
}
